module.exports = __webpack_public_path__ + "img/whatsapp.2321ecbe.svg";